module.exports = __webpack_public_path__ + "static/media/popover.82399777.png";